import * as XLSX from 'xlsx';

const importFromExcel = (file) => {
  return new Promise((resolve, reject) => {

    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);

        const workbook = XLSX.read(data, { type: 'array' });

        const sheetName = workbook.SheetNames[0];

        const worksheet = workbook.Sheets[sheetName];

        // convert excel to json
        const jsonData = XLSX.utils.sheet_to_json(
          worksheet,
          { defval: '' } // empty values also keep
        );

        if (!jsonData || jsonData.length === 0) {
          reject(new Error('Excel file is empty'));
          return;
        }

        resolve(jsonData);

      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsArrayBuffer(file);
  });
};

export { importFromExcel };